export default __webpack_public_path__ + "static/images/trade.6de1432e.png";